/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Postal/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Addresses from './Addresses/index'
import Heading from './Heading/index'
import NewAddress from './NewAddress/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Postal({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Postal.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-Z2f7uP4': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-2-Z2f7uP4': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Addresses
  viewPath={`${viewPath}/Addresses`}
/>
</div>
<NewAddress
  viewPath={`${viewPath}/NewAddress`}
/>
{children}
</React.Fragment>)
}